import { render, staticRenderFns } from "./StatisticTabsLiteV2.vue?vue&type=template&id=3ea86d04&scoped=true&"
import script from "./StatisticTabsLiteV2.vue?vue&type=script&lang=js&"
export * from "./StatisticTabsLiteV2.vue?vue&type=script&lang=js&"
import style0 from "./StatisticTabsLiteV2.vue?vue&type=style&index=0&id=3ea86d04&prod&scoped=true&lang=css&"
import style1 from "./StatisticTabsLiteV2.vue?vue&type=style&index=1&id=3ea86d04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea86d04",
  null
  
)

export default component.exports